<template>
  <v-container fluid class="hide headerBG" style="min-height: 100vh">
    <v-btn fixed left class="print-hidden white--text ptsColor" @click="$router.back()">
      <v-icon class>reply</v-icon>
      <span class>{{$t('return')}}</span>
    </v-btn>
    <v-btn
      icon
      large
      fixed
      @click="printContent"
      color="amber darken-2"
      class="print-hidden white--text"
    >
      <v-icon>print</v-icon>
    </v-btn>
    <v-layout wrap mt-5 justify-center class="hide">
      <div v-html="billData.html"></div>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters("ReportsModule", { billData: "billData" }),
    styles() {
      return { "min-height": "297mm", width: "200mm" };
    }
  },
  methods: {
    printContent() {
      window.print();
    }
  }
};
</script> 